const {stripHashIfExists} = require('../helpers/dataUtils')
const experimentName = 'dm_pageWithItemLayoutFixer'

/** Remove itemLayout property from Page layouts (EDIX-26800)
 * @param {{ structure: any; data: any; }} pageJson
 * @param _pageIds
 * @param magicObject
 */
function exec(pageJson, _pageIds, magicObject) {
    const isExperimentOpen = magicObject.isExperimentOpen(experimentName)
    if (!isExperimentOpen) {
        return
    }
    const layoutItem = getLayoutItem(pageJson)
    if (!layoutItem) {
        return
    }
    layoutItem.itemLayout = {}
}
/** Find the problematic item or return null
 * @param {{ structure: any; data: any; }} pageJson
 */
function getLayoutItem(pageJson) {
    const {structure, data} = pageJson

    const layoutData = data.layout_data ?? {}
    const layoutQuery = stripHashIfExists(structure.layoutQuery)
    const directLayoutItem = layoutData[layoutQuery]
    if (directLayoutItem?.type !== 'RefArray') {
        // Not the scenario we're looking for
        return null
    }
    const layoutId = stripHashIfExists(directLayoutItem.values?.[0])
    return layoutData[layoutId] ?? null
}
module.exports = {
    name: 'pageWithItemLayoutFixer',
    version: 0,
    exec,
    fixerRequiresReruns: true,
    experimentalVersions: [{version: 1, experiment: experimentName}]
}
